// index.js
import React from 'react';
import { createRoot } from 'react-dom'; // Importeer createRoot in plaats van ReactDOM
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

createRoot(document.getElementById('root')).render(
    <Router>
        <App />
    </Router>
);